import { L10n } from '@syncfusion/ej2-base';
import richTextEditorLocale from './jsons/richTextEditorLocale.json';

let isLoaded = false;

const loadRichTextEditorLocale = () => {
    if (isLoaded) return;

    L10n.load({
        he: { richtexteditor: richTextEditorLocale.he },
        ar: { richtexteditor: richTextEditorLocale.ar },
    });

    isLoaded = true;
};

export default loadRichTextEditorLocale;
